/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AttendanceTypeEnum,
  AttendanceTypeEnumOptional,
  AttendanceTypeEnumMetaI,
  AttendanceTypeEnumTrackedI,
} from "./attendance-type-enum";
import {
  AttendanceTypeEnumTracked,
  AttendanceTypeEnumMeta,
} from "./attendance-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupFullDTO,
  ClassSignupFullDTOOptional,
  ClassSignupFullDTOMetaI,
  ClassSignupFullDTOTrackedI,
} from "./class-signup-full-dto";
import {
  ClassSignupFullDTOTracked,
  ClassSignupFullDTOMeta,
} from "./class-signup-full-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassAttendanceFull,
  UnifiedClassAttendanceFullOptional,
  UnifiedClassAttendanceFullMetaI,
  UnifiedClassAttendanceFullTrackedI,
} from "./unified-class-attendance-full";
import {
  UnifiedClassAttendanceFullTracked,
  UnifiedClassAttendanceFullMeta,
} from "./unified-class-attendance-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSessionRef,
  UnifiedClassSessionRefOptional,
  UnifiedClassSessionRefMetaI,
  UnifiedClassSessionRefTrackedI,
} from "./unified-class-session-ref";
import {
  UnifiedClassSessionRefTracked,
  UnifiedClassSessionRefMeta,
} from "./unified-class-session-ref";

/**
 *
 * @export
 * @interface ClassAttendanceDTO
 */
export interface ClassAttendanceDTOOptional extends UnifiedClassAttendanceFullOptional {
  /**
   *
   * @type {number}
   * @memberof ClassAttendanceDTO
   */
  assignId?: number;
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof ClassAttendanceDTO
   */
  attend?: AttendanceTypeEnum;
  /**
   *
   * @type {UnifiedClassSessionRef}
   * @memberof ClassAttendanceDTO
   */
  sessionId?: UnifiedClassSessionRefOptional;
  /**
   *
   * @type {ClassSignupFullDTO}
   * @memberof ClassAttendanceDTO
   */
  signupId?: ClassSignupFullDTOOptional;
}

export interface ClassAttendanceDTO
  extends ClassAttendanceDTOOptional, UnifiedClassAttendanceFull {
  /**
   *
   * @type {number}
   * @memberof ClassAttendanceDTO
   */
  assignId: number;
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof ClassAttendanceDTO
   */
  attend?: AttendanceTypeEnum;
  /**
   *
   * @type {UnifiedClassSessionRef}
   * @memberof ClassAttendanceDTO
   */
  sessionId: UnifiedClassSessionRef;
  /**
   *
   * @type {ClassSignupFullDTO}
   * @memberof ClassAttendanceDTO
   */
  signupId: ClassSignupFullDTO;
}

export interface ClassAttendanceDTOTrackedI extends UnifiedClassAttendanceFullOptional {
  /**
   *
   * @type {number}
   * @memberof ClassAttendanceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof ClassAttendanceDTO
   */
  attend?: AttendanceTypeEnum;
  attendIsSet: boolean;
  /**
   *
   * @type {UnifiedClassSessionRef}
   * @memberof ClassAttendanceDTO
   */
  sessionId?: UnifiedClassSessionRefTrackedI;
  sessionIdIsSet: boolean;
  /**
   *
   * @type {ClassSignupFullDTO}
   * @memberof ClassAttendanceDTO
   */
  signupId?: ClassSignupFullDTOTrackedI;
  signupIdIsSet: boolean;
}

transformDatesMap.set(
  "ClassAttendanceDTO",
  function (model: ClassAttendanceDTO) {
    const transformDatessessionId = transformDatesMap.get(
      "UnifiedClassSessionRef",
    );
    if (transformDatessessionId && model.sessionId) {
      transformDatessessionId(model.sessionId);
    }
    const transformDatessignupId = transformDatesMap.get("ClassSignupFullDTO");
    if (transformDatessignupId && model.signupId) {
      transformDatessignupId(model.signupId);
    }
  },
);

export type ClassAttendanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  attend: PropertyMeta<AttendanceTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  sessionId: PropertyMeta<UnifiedClassSessionRefMetaI>;
  //isDate: false
  //isDatetime: false
  signupId: PropertyMeta<ClassSignupFullDTOMetaI>;
}>;

export var ClassAttendanceDTOMeta: ClassAttendanceDTOMetaI =
  {} as ClassAttendanceDTOMetaI;
ClassAttendanceDTOMeta = typeMeta("ClassAttendanceDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  attend: propertyMeta("attend", false, false, false, AttendanceTypeEnumMeta),
  sessionId: propertyMeta(
    "sessionId",
    false,
    true,
    false,
    UnifiedClassSessionRefMeta,
  ),
  signupId: propertyMeta(
    "signupId",
    false,
    true,
    false,
    ClassSignupFullDTOMeta,
  ),
});

const metaI = ClassAttendanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassAttendanceFullMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassAttendanceFullMeta.assignId;
  metaI.attend.inheritedFrom = UnifiedClassAttendanceFullMeta.attend;
  metaI.sessionId.inheritedFrom = UnifiedClassAttendanceFullMeta.sessionId;
  metaI.signupId.inheritedFrom = UnifiedClassAttendanceFullMeta.signupId;
});

export class ClassAttendanceDTOTracked
  extends UnifiedClassAttendanceFullTracked
  implements ClassAttendanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  attend__I?: AttendanceTypeEnum = undefined;
  attendIsSet: boolean = false;
  set attend(v: undefined | AttendanceTypeEnum) {
    if (v !== undefined) {
      this.attend__I = v;
      this.attendIsSet = true;
    } else {
      this.attend__I = v || undefined;
      this.attendIsSet = false;
    }
    this.changeTracker = true;
  }
  get attend() {
    return this.attend__I;
  }
  sessionId__I?: UnifiedClassSessionRefTracked = undefined;
  sessionIdIsSet: boolean = false;
  set sessionId(v: undefined | UnifiedClassSessionRefTracked) {
    if (v !== undefined) {
      this.sessionId__I = v;
      this.sessionIdIsSet = true;
    } else {
      this.sessionId__I = v || undefined;
      this.sessionIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get sessionId() {
    return this.sessionId__I;
  }
  signupId__I?: ClassSignupFullDTOTracked = undefined;
  signupIdIsSet: boolean = false;
  set signupId(v: undefined | ClassSignupFullDTOTracked) {
    if (v !== undefined) {
      this.signupId__I = v;
      this.signupIdIsSet = true;
    } else {
      this.signupId__I = v || undefined;
      this.signupIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get signupId() {
    return this.signupId__I;
  }
  constructor(config?: ClassAttendanceDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.sessionId?.setIds();

    this.signupId?.setIds();
  }
  assignFrom(
    config: ClassAttendanceDTOOptional,
    options?: AssignOptions,
  ): ClassAttendanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.attend && this.attendApplyFilter(optionsRequired.filter)) {
      this.attend = config.attend;
      if (optionsRequired.unassign) this.attendIsSet = false;
      else this.attendIsSet = true;
    }
    if (config.sessionId && this.sessionIdApplyFilter(optionsRequired.filter)) {
      this.sessionId = new UnifiedClassSessionRefTracked(
        config.sessionId,
        options,
      );
      if (optionsRequired.unassign) this.sessionIdIsSet = false;
      else this.sessionIdIsSet = true;
    }
    if (config.signupId && this.signupIdApplyFilter(optionsRequired.filter)) {
      this.signupId = new ClassSignupFullDTOTracked(config.signupId, options);
      if (optionsRequired.unassign) this.signupIdIsSet = false;
      else this.signupIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassAttendanceDTOTrackedI {
    const cloned = {} as ClassAttendanceDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.attendIsSetDeep() &&
      this.attendApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.attendIsSet = true;
      cloned.attend = this.attend;
    } else {
      //cloned.attendIsSet = false
    }
    if (
      this.sessionIdIsSetDeep() &&
      this.sessionIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionIdIsSet = true;
      cloned.sessionId = this.sessionId?.removeUnset(filter);
    } else {
      //cloned.sessionIdIsSet = false
    }
    if (
      this.signupIdIsSetDeep() &&
      this.signupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupIdIsSet = true;
      cloned.signupId = this.signupId?.removeUnset(filter);
    } else {
      //cloned.signupIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassAttendanceDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.attendApplyFilter(filter)) this.attendIsSet = false;

    if (!this.sessionIdApplyFilter(filter)) this.sessionIdIsSet = false;
    this.sessionId?.unassignAll(filter);

    if (!this.signupIdApplyFilter(filter)) this.signupIdIsSet = false;
    this.signupId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAttendanceDTOMeta.assignId,
      ClassAttendanceDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  attendApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAttendanceDTOMeta.attend,
      ClassAttendanceDTOMeta,
      this.attend,
      this,
    );
  }
  attendIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.attendIsSet && this.attendApplyFilter(filter)) return true;

    return false;
  }
  sessionIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAttendanceDTOMeta.sessionId,
      ClassAttendanceDTOMeta,
      this.sessionId,
      this,
    );
  }
  sessionIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionIdIsSet && this.sessionIdApplyFilter(filter)) return true;
    return this.sessionId?.anySet(filter) == true;

    return false;
  }
  signupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassAttendanceDTOMeta.signupId,
      ClassAttendanceDTOMeta,
      this.signupId,
      this,
    );
  }
  signupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupIdIsSet && this.signupIdApplyFilter(filter)) return true;
    return this.signupId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.attendIsSetDeep(filter)) return true;
    if (this.sessionIdIsSetDeep(filter)) return true;
    if (this.signupIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
